import { Bean } from '@dreryk/react-common';

import { FormsTemplatesPortal } from '../FormsTemplates.portal';
import { FormsTemplateListItem } from '../FormsTemplates.types';
import { useFormsTemplatesContext } from '../formsTemplatesContext';

type FormsTemplateReadOnlySectionProps<ITEM extends Bean> = {
   readonly children: (renderProps: { activeItem: FormsTemplateListItem<ITEM> }) => JSX.Element;
};

export const FormsTemplateReadOnlySection = <ITEM extends Bean>(
   props: FormsTemplateReadOnlySectionProps<ITEM>
): JSX.Element | null => {
   const { mode, activeItem } = useFormsTemplatesContext<ITEM>();

   if (mode !== 'READ_ONLY') {
      return null;
   }

   return <FormsTemplatesPortal>{props.children({ activeItem: activeItem })}</FormsTemplatesPortal>;
};
